import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  prioridades: [],
};

const getters = {
  // Prioridade
  prioridades: state => state.prioridades.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  prioridadesAtivo: state => state.prioridades.filter(p => p.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Prioridade
  async fetchPrioridades({ commit }) {
    const response = await axios.get(`${baseUrl}/prioridades`);
    if (response.data) {
      commit('setPrioridades', response.data);
    } else {
      commit('setPrioridades', []);
    }
  },
  async fetchPrioridadesSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/prioridades?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setPrioridades', response.data);
      } else {
        commit('setPrioridades', []);
      }
    } catch (error) {
      commit('setPrioridades', []);
    }
  },
  async addPrioridade({ commit }, prioridade) {
    const response = await axios.post(`${baseUrl}/prioridades`, prioridade, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    prioridade.IdPrioridade = response.data.IdPrioridade;
    commit('newPrioridade', prioridade);
    return response.data.IdPrioridade;
  },
  async updatePrioridade({ commit }, updPrioridade) {
    await axios.put(`${baseUrl}/prioridades`, updPrioridade, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updatePrioridade', updPrioridade);
  },
  async deletePrioridade({ commit }, id) {
    await axios.delete(`${baseUrl}/prioridades/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removePrioridade', id);
  },
}

const mutations = {
  // Prioridade
  setPrioridades: (state, prioridades) => state.prioridades = prioridades,
  newPrioridade: (state, prioridade) => state.prioridades.push(prioridade),
  removePrioridade: (state, id) => state.prioridades = state.prioridades.filter(prioridade => prioridade.IdPrioridade !== id),
  updatePrioridade: (state, updPrioridade) => {
    const index = state.prioridades.findIndex(prioridade => prioridade.IdPrioridade === updPrioridade.IdPrioridade);
    if (index !== -1) {
      state.prioridades.splice(index, 1, updPrioridade);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}